/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Loading } from '@orientaction/commons/Loading';
import OaLabel from '@orientaction/commons/OaLabel';
import StyledDropzone from '@orientaction/commons/StyledDropzone';
import { AdminTestContext } from '@orientaction/Context';
import { uploadImageAsync } from '@orientaction/utils';
import classNames from 'classnames';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import YoutubeIframe from '../../../../../VideoYoutubeEmbed';
import ResponsesSection from '../ResponsesSection';
import style from './style';
import RichEditor from '@orientaction/commons/RichEditor';

const QuestionForm = ({ idAglomeration }: any) => {
  const [title, setTitle] = useState<string>();
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const [mediaType, setMediaType] = useState(
    test?.questionAglomerationToCreate?.mediaType || 'none'
  );
  const [mediaUrl, setMediaUrl] = useState(test?.questionAglomerationToCreate?.mediaUrl || '');
  const [isUploading, setIsUploading] = useState(false);
  const [timer, setTimer] = useState(test?.test?.globalTimer);

  const quillRef: any = useRef();

  const classes = style();

  const initializeEditState = useCallback(() => {
    const { questionAglomerationToEdit } = test;
    setTitle(questionAglomerationToEdit.title);
    if (questionAglomerationToEdit.mediaUrl) {
      setMediaType(questionAglomerationToEdit.mediaType || 'image');
      setMediaUrl(questionAglomerationToEdit.mediaUrl);
    }
  }, [test]);

  const initializeState = useCallback(() => {
    const { questionAglomerationToCreate } = test;
    setTitle(questionAglomerationToCreate.title);
    if (questionAglomerationToCreate.mediaUrl) {
      setMediaType(questionAglomerationToCreate.mediaType || 'image');
      setMediaUrl(questionAglomerationToCreate.mediaUrl);
    }
  }, [test]);

  const handleChange = (value: string) => {
    setTitle(value);
    updateTest({
      questionAglomerationToCreate: {
        ...test.questionAglomerationToCreate,
        title: value,
        errors: {
          ...test?.questionAglomerationToCreate?.errors,
          title: false,
        },
      },
    });
  };

  const handleMediaTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newType = event.target.value;
    setMediaType(newType);
    if (newType === 'none') {
      setMediaUrl('');
    }
    updateTest({
      questionAglomerationToCreate: {
        ...test.questionAglomerationToCreate,
        mediaType: newType,
        mediaUrl: newType === 'none' ? '' : test.questionAglomerationToCreate.mediaUrl,
      },
    });
  };

  const handleMediaUrlChange = async (url: string) => {
    if (mediaType === 'image') {
      setIsUploading(true);
      try {
        const uploadedUrl = await uploadImageAsync(url, 'questions');
        setMediaUrl(uploadedUrl);
        updateTest({
          questionAglomerationToCreate: {
            ...test.questionAglomerationToCreate,
            mediaUrl: uploadedUrl,
          },
        });
      } finally {
        setIsUploading(false);
      }
    } else {
      setMediaUrl(url);
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          mediaUrl: url,
        },
      });
    }
  };

  const handleDeleteMedia = () => {
    setMediaUrl('');
    updateTest({
      questionAglomerationToCreate: {
        ...test.questionAglomerationToCreate,
        mediaUrl: '',
      },
    });
  };

  useEffect(() => {
    if (test.questionToEdit) {
      initializeEditState();
    }
    if (test.questionAglomerationToCreate) {
      initializeState();
    }
  }, [initializeEditState, test.questionToEdit]);

  const showError =
    !test?.questionAglomerationToCreate?.responses?.length &&
    test?.questionAglomerationToCreate?.errors?.response;

  const showMediaError =
    mediaType !== 'none' && !mediaUrl && test?.questionAglomerationToCreate?.errors?.mediaUrl;

  const questionIndex = test?.aglomerations[idAglomeration].questions.findIndex(
    (q: any) => q.id === test?.questionAglomerationToCreate?.id
  );
  const questionNumber =
    questionIndex === -1
      ? test?.aglomerations[idAglomeration].questions.length + 1
      : questionIndex + 1;

  const handleChangeTimer = (event: any) => {
    const { value } = event.target;
    if (value === '' || Number(value) >= 0) {
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          timer: Number(value),
        },
      });
      setTimer(Number(value));
    }
  };

  return (
    <>
      <form className={classes.flexContainer}>
        <Typography className={classes.questionFormTitle} component="h3">
          Question N°{questionNumber}
        </Typography>
        <div className={classNames(classes.marginTop, classes.textInputContainer)}>
          <OaLabel>Titre de la question</OaLabel>
          <RichEditor
            ref={quillRef}
            value={title}
            handleChange={handleChange}
            placeholder="Renseignez le titre de la question"
            isMultiline={true}
            hasError={test?.questionToCreate?.errors?.title}
          />
        </div>

        <div className={classNames(classes.marginTop, classes.textInputContainer)}>
          <OaLabel>Image ou vidéo de la question</OaLabel>
          <RadioGroup row value={mediaType} onChange={handleMediaTypeChange}>
            <FormControlLabel value="none" control={<Radio color="primary" />} label="Aucun" />
            <FormControlLabel
              value="image"
              control={<Radio color="primary" />}
              label={
                <span>
                  Image{' '}
                  <span style={{ color: '#666', fontSize: '0.9em' }}>
                    (Format 4/3 - Taille min. 350 x 263px)
                  </span>
                </span>
              }
            />
            <FormControlLabel value="video" control={<Radio color="primary" />} label="Vidéo" />
          </RadioGroup>

          {mediaType === 'image' && (
            <div className={classes.imageContainer}>
              {!mediaUrl ? (
                <div style={{ width: 300, height: 226, position: 'relative' }}>
                  <StyledDropzone
                    fileUrl={mediaUrl}
                    handleFileUrlChange={handleMediaUrlChange}
                    pathPrefix="questions"
                    placeholder={() => (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          color: '#0E1247',
                        }}>
                        <span style={{ fontSize: '24px', marginBottom: '8px' }}>+</span>
                        <span>Importer une image</span>
                      </div>
                    )}
                  />
                  {isUploading && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(250, 250, 250, 0.9)',
                      }}>
                      <Loading />
                    </div>
                  )}
                </div>
              ) : (
                <div className={classes.imagePreviewContainer}>
                  <img src={mediaUrl} alt="Preview" className={classes.imagePreview} />
                  <Button
                    onClick={handleDeleteMedia}
                    style={{
                      color: '#FF0000',
                      textTransform: 'none',
                      textDecoration: 'none',
                      marginTop: '8px',
                      padding: 0,
                    }}>
                    Supprimer
                  </Button>
                </div>
              )}
            </div>
          )}

          {mediaType === 'video' && (
            <div className={classes.videoContainer}>
              <TextField
                fullWidth
                placeholder="Url de la vidéo Youtube"
                value={mediaUrl}
                onChange={e => handleMediaUrlChange(e.target.value)}
                error={showMediaError}
                helperText={showMediaError ? "L'URL de la vidéo est obligatoire*" : ''}
                variant="outlined"
                InputProps={{
                  style: {
                    borderRadius: 8,
                    height: 48,
                    border: '1px solid #E0E3F0',
                    backgroundColor: 'white',
                    fontSize: '14px',
                  },
                }}
                className={classes.customTextField}
              />
              {mediaUrl && (
                <div
                  style={{
                  marginTop: 16,
                  backgroundColor: '#F5F6FA',
                  borderRadius: 8,
                  padding: 16,
                  display: 'flex',
                  flexDirection: 'column',
                    alignItems: 'flex-start',
                }}>
                  <div className={classes.videoPreviewContainer}>
                    <YoutubeIframe url={mediaUrl} />
                    <Button
                      onClick={handleDeleteMedia}
                      style={{
                        color: '#FF0000',
                        textTransform: 'none',
                        textDecoration: 'none',
                        marginTop: 16,
                        padding: 0,
                        display: 'block',
                        margin: '16px auto 0',
                      }}>
                      Supprimer
                    </Button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {/* {test.test.useGlobalTimer && (
          <div className={classNames(classes.marginTop, classes.textInputContainer)}>
            <OaLabel>Modifier la limite de temps pour cette question</OaLabel>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                onChange={handleChangeTimer}
                name="timer"
                value={timer || ''}
                type="number"
                placeholder="30"
                variant="outlined"
                className={classes.formInput}
              />
              <span style={{ fontSize: 12, color: '#151528', marginLeft: 5 }}>secondes</span>
            </div>
          </div>
        )} */}
      </form>
      <ResponsesSection responses={test?.questionAglomerationToCreate?.responses} />
      {showError && (
        <Typography component="h5" className={showError ? classes.responseError : ''}>
          La réponse est obligatoire*
        </Typography>
      )}
    </>
  );
};

export default QuestionForm;
